import { createClient } from '@supabase/supabase-js';
// import { Database } from './model.types';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTY0MTkwMzk5MiwiZXhwIjoxOTU3NDc5OTkyfQ.L_xHuzYB59P95EV0ycoFn6IxDg0NvQdtmPVxIlaquRo';
const SUPABASE_URL = 'https://mggdjmnpopvejdwcoscu.supabase.co';

// export const supabase = createClient < Database > (SUPABASE_URL, SUPABASE_KEY);

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
// export  supabase ;
